// Module
var code = "<i> <span ng-if=\"isDifferent()\" class=\"fa fa-flag\" data-popover=\"{{ 'Current ' + label + ': ' + (currentDisplayValue || currentValue) }}\" popover-placement=\"top\" popover-append-to-body=\"true\" popover-trigger=\"mouseenter\"> </span> </i> ";
// Exports
module.exports = code;